import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularDeviceInformationService } from 'angular-device-information';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false, 
  styleUrls: ['./app.component.scss'],  
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit{
  constructor( ) {
}
ngOnInit(): void {
}
}
